import React from 'react';
import { Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { IPCheckSession } from 'store/types/Meeting';
import { QuestionResponse } from 'store/enums/BallotReviewTypes';

interface CopyrightedSummaryViewCardProps {
  ipCheckSession: IPCheckSession;
}

const CopyrightedSummaryViewCard: React.FunctionComponent<CopyrightedSummaryViewCardProps> = ({ ipCheckSession }) => {
  const copyrightConflictAnswer =
    ipCheckSession.copyrightConflict === QuestionResponse.Yes
      ? 'There is at least one known copyrighted items that might be relevant to the Standard/Safety Guideline'
      : ipCheckSession.copyrightConflict === QuestionResponse.No
      ? 'There is no disclosed copyrighted item'
      : '';

  return (
    <GridContainer>
      <GridItem>
        <Card title={<Typography variant="h6">Copyrighted Item Subsection</Typography>} bordered>
          <GridContainer spacing={1}>
            <GridItem md={12}>
              <Typography>Total numbers of copyrighted items to be dealt with</Typography>
            </GridItem>
            <GridItem md={12}>
              <Typography>
                <strong>Known copyrighted items that are used or reproduced to the Standard/Safety Guideline: </strong>
                {ipCheckSession.copyrightSummary?.totalConflicts ?? ''}
              </Typography>
            </GridItem>
            {ipCheckSession.copyrightConflict && (
              <GridItem md={12}>
                <Typography>{copyrightConflictAnswer}</Typography>
              </GridItem>
            )}
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default CopyrightedSummaryViewCard;
